import { BaseReactiveClass } from 'Classes/BaseReactiveClass';
import * as accountApi from 'Api/account';
import { RISK_TOLERANCE_OPTIONS, TIME_HORIZON_OPTIONS } from '../forms/FormAccountSuitability/const/account-suitability-investment';

// TODO move to static variable into this class
export class ModelAccountSuitability extends BaseReactiveClass {
  constructor(data) {
    super(data);

    this.$set('$dataLoading', false);
  }

  get isRiskToleranceNotSuitable() {
    const selecteItem = RISK_TOLERANCE_OPTIONS.find(item => item.value === this.risk_tolerance);
    return Boolean(selecteItem?.message);
  }

  get isTimeHorizonNotSuitable() {
    const selecteItem = TIME_HORIZON_OPTIONS.find(item => item.value === this.time_horizon);
    return Boolean(selecteItem?.message);
  }

  get isInvestmentNotSuitable() {
    return this.isRiskToleranceNotSuitable || this.isTimeHorizonNotSuitable;
  }

  // employment_status is field from last suitability form. If it's not empty, means all 2 suitability form passed
  get isSuitabilityPassed() {
    return Boolean(this.employment_status);
  }

  // check if account is fin regulator
  get isFinRegulator() {
    return this.is_fin_regulator;
  }

  static fetchData(accountId) {
    return accountApi.getAccountSuitability(accountId);
  }

  static async buildClass(accountId) {
    const data = await ModelAccountSuitability.fetchData(accountId);
    return new ModelAccountSuitability(data);
  }

  async load() {
    if (!this.accountId) return;
    const data = await ModelAccountSuitability.fetchData(this.accountId);
    this.$setAll(data);
  }

  async update() {
    return this.load();
  }
}
